(function (app, ng) {
    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state("Home.Tools.MarketingTracker.Kits.Onboarding",
                {
                    url: "/Onboarding",
                    component: "onboardingKit",
                    PageTitle: "Marketing Tracker - Onboarding Kit",
                    resolve: {
                        attempt: ["marketingKitApi", function (marketingKitApi) {
                            return marketingKitApi.getOnboardingKit().then(function (kit) {
                                return kit;
                            }, function () {
                                return null;
                            });
                        }]
                    }
                });
    }]);

    app
        .component("onboardingKit",
            {
                templateUrl: "App/Tools/MarketingTracker/Kits/Onboarding/onboarding-template.html",
                controller: onboardingKitController,
                bindings: {
                    attempt: "<"
                }
            });

    onboardingKitController.$inject = ["marketingKitApi", "$timeout", "$mdDialog", "$window"];

    function onboardingKitController(marketingKitApi, $timeout, $mdDialog, $window) {
        var $ctrl = this;

        if ($ctrl.attempt !== null) {
            console.log($ctrl.attempt.IsSubmitted)
            $ctrl.isSubmitted = $ctrl.attempt.IsSubmitted;
            $ctrl.form = JSON.parse($ctrl.attempt.JsonData);
            $ctrl.formCopy = ng.copy($ctrl.form);
        }
        else $ctrl.attempt = {};

        ng.extend($ctrl,
            {
                save: save,
                autoSave: autoSave,
                error: error,
                UI: {
                    isSaving: false,
                    isSubmitting: false,
                    submitMessage: "Your Onboarding kit has been submitted.",
                    saveMessage: "Your Onboarding kit has been saved.",
                    autoSaveMessage: "Your Onboarding kit has been auto saved."
                }
            });

        function autoSave($event) {
            $timeout.cancel($ctrl.autoSaveTimeout);
            if ($event.ctrlKey && $event.keyCode === 83) {
                $event.preventDefault();
                save($ctrl.form, false, false);
            } else {
                $ctrl.autoSaveTimeout = $timeout(function () {
                    if (!ng.equals($ctrl.form, $ctrl.formCopy) && !$ctrl.isAutoSaved) {
                        save($ctrl.form, false, true);
                    }
                }, 5000);
            }
        }

        function error($event) {
            var errorMsg = $mdDialog.alert({
                title: "We're sorry, there was an error saving your kit. Please contact your sales consultant if this error continues.",
                targetEvent: $event,
                ariaLabel: "Saving Error",
                ok: "OK",

                multiple: true,
                clickOutsideToClose: false
            });

            $mdDialog.show(errorMsg).then(function () {
                $mdDialog.hide();
                $window.location.reload();
            });
        }

        function save(form, isSubmitted, autoSaved) {
            if (isSubmitted) {
                $ctrl.UI.isSubmitting = true;
                $ctrl.attempt.IsSubmitted = true;
            } else {
                $ctrl.UI.isSaving = true;
                $ctrl.attempt.IsSubmitted = false;
            }

            $ctrl.attempt.JsonData = JSON.stringify(form);

            marketingKitApi.saveOnboardingKit($ctrl.attempt).then(function () {

                $ctrl.isSubmitted = isSubmitted;

                if (!isSubmitted) {
                    autoSaved ? $ctrl.isAutoSaved = true : $ctrl.isSaved = true;
                    $ctrl.form = JSON.parse($ctrl.attempt.JsonData);
                    $ctrl.formCopy = ng.copy($ctrl.form);
                    $timeout(function () {
                        $ctrl.isSaved = false;
                        $ctrl.isAutoSaved = false;
                    }, 2000);
                }

                $ctrl.UI.isSubmitting = false;
                $ctrl.UI.isSaving = false;
            }, function () {
                $ctrl.UI.isSubmitting = false;
                $ctrl.UI.isSaving = false;
                error();
            });
        }
    }

})(window.app, window.angular); // jshint ignore:line